// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1nKBJ","inputWrap":"Table_inputWrap__BlHTF","col":"Table_col__2_jvT","bmiTooltip":"Table_bmiTooltip__3L9Bb"};